import { Component } from '@angular/core';
import { FormBuilder, Formio } from 'formiojs';
import { Router } from '@angular/router';
import * as moment from 'moment';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
})
export class HomeComponent {
  // Formio.builder(document.getElementById('builder'), {}).then(function(form){
  //   form.webform.submission = {
  //       data: prefilledDataObject
  //   };
// });

formSpec: any;
formData: any;
router: Router;
moment = moment;
constructor(router: Router) {
  this.router = router;
}

ngOnInit() {
var checkRefDate = moment().add(-3, 'months').toISOString();
this.formSpec = {
  "title": "My Test Form",
  "components": [
    {
      "html": "<p>This application form covers the nomination of dispute resolvers for mediations, arbitration, expert determination and conciliations.</p><p>This form requires the following information:</p><p>- Contact details of ALL parties and legal representatives (name, email, phone number, postal address, etc)</p><p>- Amount disputed.</p><p>- Area of dispute.</p><p>- Brief outline of dispute.</p><p>Please also attach: Dispute Resolution clause (if any), Notice of dispute and any other relevant documentation. This MUST be in PDF format.</p>",
      "label": "Content",
      "refreshOnChange": false,
      "key": "content",
      "type": "content",
      "input": false,
      "tableView": false
    },
    {
      "type": "radio",
      "label": "I acknowledge the above",
      "input": true,
      "inline": true,
      "tableView": false,
      "key": "terms",
      "persistent": true,
        values: [
          {value: 'yes', label: 'Yes'},
          {value: 'no', label: 'No'}
        ],
      //   "validate": {
      //     "required": true
      // }
    },
    {
      type: "select",
      label: "Which state did the construction work take place in?",
      key: "applicantState",
      placeholder: "Select one",
      data: {
        values: [
          {value: 'NSW', label: 'NSW'},
          {value: 'VIC', label: 'VIC'},
          {value: 'SA', label: 'SA'},
          {value: 'ACT', label: 'ACT'},
          {value: 'TAS', label: 'TAS'}
        ]
      },
      dataSrc: "values",
      defaultValue: '',
      template: "<span>{{ item.label }}</span>",
      input: true,
      conditional: {
        "json": {
          "===": [
            {
              "var": "data.terms"
            },
            "yes"
          ]
        }
      }
    },
    {
      "type": "htmlelement",
      "input": false,
      "tableView": true,
      "content": "the relevant legislation is <a href='http://www8.austlii.edu.au/cgi-bin/viewdb/au/legis/nsw/consol_act/bacisopa1999606/' target='_blank'>'NSW Building and Construction Industry Security of Payments Act 1999'</a> and will be referred to from hereon as ‘the Act’",
      "inputMask": "",
      "key": "applicantNswText",
      "prefix": "",
      "suffix": "",
      "multiple": false,
      "protected": false,
      "unique": false,
      "persistent": true,
      "conditional": {
        "json": {
          "===": [
            {
              "var": "data.applicantState"
            },
            "NSW"
          ],
        }
      }
  },
  {
    "type": "htmlelement",
    "input": false,
    "tableView": true,
    "content": "he relevant legislation is <a href='http://www8.austlii.edu.au/cgi-bin/viewdb/au/legis/vic/consol_act/bacisopa2002606/' target='_blank'>'VIC Building and Construction Industry Security of Payments Act 2002'</a> and will be referred to from hereon as ‘the Act’",
    "inputMask": "",
    "key": "applicantVicText",
    "prefix": "",
    "suffix": "",
    "multiple": false,
    "protected": false,
    "unique": false,
    "persistent": true,
    "conditional": {
      "json": {
        "===": [
          {
            "var": "data.applicantState"
          },
          "VIC"
        ],
      }
    }
},
{
  "type": "htmlelement",
  "input": false,
  "tableView": true,
  "content": "the relevant legislation is for <a href='http://www8.austlii.edu.au/cgi-bin/viewdb/au/legis/tas/consol_act/bacisopa2009606/' target='_blank'>'TAS Building and Construction Industry Security of Payments Act 2009'</a> and will be referred to from hereon as ‘the Act’",
  "inputMask": "",
  "key": "applicantTasText",
  "prefix": "",
  "suffix": "",
  "multiple": false,
  "protected": false,
  "unique": false,
  "persistent": true,
  "conditional": {
    "json": {
      "===": [
        {
          "var": "data.applicantState"
        },
        "TAS"
      ],
    }
  }
},
{
  "type": "htmlelement",
  "input": false,
  "tableView": true,
  "content": "the relevant legislation is for <a href='http://www8.austlii.edu.au/cgi-bin/viewdb/au/legis/sa/consol_act/bacisopa2009606/' target='_blank'>'SA Building and Construction Industry Security of Payments Act 2009'</a> and will be referred to from hereon as ‘the Act’",
  "inputMask": "",
  "key": "applicantSaText",
  "prefix": "",
  "suffix": "",
  "multiple": false,
  "protected": false,
  "unique": false,
  "persistent": true,
  "conditional": {
    "json": {
      "===": [
        {
          "var": "data.applicantState"
        },
        "SA"
      ],
    }
  }
},
{
  "type": "htmlelement",
  "input": false,
  "tableView": true,
  "content": "the relevant legislation is for <a href='http://www8.austlii.edu.au/cgi-bin/viewdb/au/legis/act/consol_act/baciopa2009606/' target='_blank'>'ACT Building and Construction Industry Security of Payments Act 2009'</a> and will be referred to from hereon as ‘the Act’",
  "inputMask": "",
  "key": "applicantActText",
  "prefix": "",
  "suffix": "",
  "multiple": false,
  "protected": false,
  "unique": false,
  "persistent": true,
  "conditional": {
    "json": {
      "===": [
        {
          "var": "data.applicantState"
        },
        "ACT"
      ],
    }
  }
},
  {
      "type": "textfield",
      "input": true,
      "tableView": true,
      "inputType": "text",
      "inputMask": "",
      "label": "Name of Applicant (Company)",
      "key": "applicantName",
      "placeholder": "",
      "prefix": "",
      "suffix": "",
      "multiple": false,
      "defaultValue": "",
      "protected": false,
      "unique": false,
      "persistent": true,
      "validate": {
          "required": true,
          "customPrivate": false
      },
      conditional: {
      "json": {
        "===": [
          {
            "var": "data.terms"
          },
          "yes"
        ]
      }
    }
  },
    {
      "type": "textfield",
      "input": true,
      "tableView": true,
      "inputType": "text",
      "inputMask": "",
      "label": "ABN/ACN",
      "key": "applicantABN",
      "placeholder": "",
      "prefix": "",
      "suffix": "",
      "multiple": false,
      "defaultValue": "",
      "protected": false,
      "unique": false,
      "persistent": true,
      "validate": {
          "required": true,
          "customPrivate": false,
          "pattern": "^[0-9]+$"
      },
      conditional: {
      "json": {
        "===": [
          {
            "var": "data.terms"
          },
          "yes"
        ]
      }
    }
  },
  {
    "type": "button",
    "label": "Check",
    "key": "check",
    "disableOnInvalid": false,
    "input": true,
    "tableView": true,
    "action": "custom",
    "custom": "window.onCheck(data.applicantABN)",
    // disabled: "window.checkValid(data.applicantABN)",
    conditional: {
      "json": {
        "===": [
          {
            "var": "data.terms"
          },
          "yes"
        ]
      }
    }
  },
  {
    type: "select",
    label: "Business Structure",
    key: "applicantBusinessStructure",
    placeholder: "Select one",
    data: {
      values: [
        {value: 'Commonwealth Government', label: 'Commonwealth Government'},
        {value: 'Incorporated Association', label: 'Incorporated Association'},
        {value: 'Local Government', label: 'Local Government'},
        {value: 'Ltd Company', label: 'Ltd Company'},
        {value: 'Local Government', label: 'Local Government'},
        {value: 'Partnership', label: 'Partnership'},
        {value: 'Pty Ltd Company', label: 'Pty Ltd Company'},
        {value: 'Sole trader', label: 'Sole trader'},
        {value: 'State Government', label: 'State Government'},
        {value: 'Trust', label: 'Trust'},
        {value: 'Other', label: 'Other'}
      ]
    },
    dataSrc: "values",
    validate:{
      required: true
    },
    conditional: {
      "json": {
        "===": [
          {
            "var": "data.terms"
          },
          "yes"
        ]
      }
    },
    defaultValue: '',
    template: "<span>{{ item.label }}</span>",
    input: true
  },
  {
    type: "select",
    label: "Business Type/Activity",
    key: "applicantBusinessType",
    placeholder: "Select one",
    data: {
      values: [
        {value: 'Principal', label: 'Principal'},
        {value: 'Head contractor', label: 'Head contractor'},
        {value: 'Subcontractor', label: 'Subcontractor'},
        {value: 'Supplier', label: 'Supplier'},
        {value: 'Consultant', label: 'Consultant'},
        {value: 'Not Specified', label: 'Not Specified'}
      ]
    },
    dataSrc: "values",
    validate:{
      required: true
    },
    conditional: {
      "json": {
        "===": [
          {
            "var": "data.terms"
          },
          "yes"
        ]
      }
    },
    defaultValue: '',
    template: "<span>{{ item.label }}</span>",
    input: true
  },
  {
    "type": "htmlelement",
    "input": false,
    "tableView": true,
    "content": "Contact Person",
    "inputMask": "",
    "key": "applicantContactPersonText",
    "prefix": "",
    "suffix": "",
    "multiple": false,
    "protected": false,
    "unique": false,
    "persistent": true,
    "conditional": {
      "json": {
        "===": [
          {
            "var": "data.terms"
          },
          "yes"
        ]
      }
    }
},
  {
    "type": "textfield",
    "input": true,
    "tableView": true,
    "inputType": "text",
    "inputMask": "",
    "label": "",
    "key": "applicantContactPersonName",
    "placeholder": "Name",
    "prefix": "",
    "suffix": "",
    "multiple": false,
    "defaultValue": "",
    "protected": false,
    "unique": false,
    "persistent": true,
    "validate": {
        "required": true,
        "customPrivate": false
    },
    conditional: {
    "json": {
      "===": [
        {
          "var": "data.terms"
        },
        "yes"
      ]
    }
  }
},
{
  "type": "textfield",
  "input": true,
  "tableView": true,
  "inputType": "text",
  "inputMask": "",
  "label": "",
  "key": "applicantContactPersonPosition",
  "placeholder": "Position",
  "prefix": "",
  "suffix": "",
  "multiple": false,
  "defaultValue": "",
  "protected": false,
  "unique": false,
  "persistent": true,
  "validate": {
      "customPrivate": false
  },
  conditional: {
  "json": {
    "===": [
      {
        "var": "data.terms"
      },
      "yes"
    ]
  }
}
},
{
  "type": "htmlelement",
  "input": false,
  "tableView": true,
  "content": "Address",
  "inputMask": "",
  "key": "applicantAddressText",
  "prefix": "",
  "suffix": "",
  "multiple": false,
  "protected": false,
  "unique": false,
  "persistent": true,
  "conditional": {
    "json": {
      "===": [
        {
          "var": "data.terms"
        },
        "yes"
      ]
    }
  }
},
{
  "type": "textfield",
  "input": true,
  "tableView": true,
  "inputType": "text",
  "inputMask": "",
  "label": "",
  "key": "applicantAddressNumberStreet",
  "placeholder": "Number/Street",
  "prefix": "",
  "suffix": "",
  "multiple": false,
  "defaultValue": "",
  "protected": false,
  "unique": false,
  "persistent": true,
  "validate": {
      "required": true,
      "customPrivate": false
  },
  conditional: {
  "json": {
    "===": [
      {
        "var": "data.terms"
      },
      "yes"
    ]
  }
}
},
{
  "type": "textfield",
  "input": true,
  "tableView": true,
  "inputType": "text",
  "inputMask": "",
  "label": "",
  "key": "applicantSuburb",
  "placeholder": "Suburb",
  "prefix": "",
  "suffix": "",
  "multiple": false,
  "defaultValue": "",
  "protected": false,
  "unique": false,
  "persistent": true,
  "validate": {
      "required": true,
      "customPrivate": false
  },
  conditional: {
  "json": {
    "===": [
      {
        "var": "data.terms"
      },
      "yes"
    ]
  }
}
},
{
  "type": "textfield",
  "input": true,
  "tableView": true,
  "inputType": "text",
  "inputMask": "",
  "label": "",
  "key": "applicantState",
  "placeholder": "State",
  "prefix": "",
  "suffix": "",
  "multiple": false,
  "defaultValue": "",
  "protected": false,
  "unique": false,
  "persistent": true,
  "validate": {
      "required": true,
      "customPrivate": false
  },
  conditional: {
    "json": {
      "===": [
        {
          "var": "data.terms"
        },
        "yes"
      ]
    }
  }
},
{
  "type": "textfield",
  "input": true,
  "tableView": true,
  "inputType": "text",
  "inputMask": "",
  "label": "",
  "key": "applicantPostCode",
  "placeholder": "Postcode",
  "prefix": "",
  "suffix": "",
  "multiple": false,
  "defaultValue": "",
  "protected": false,
  "unique": false,
  "persistent": true,
  "validate": {
      "required": true,
      "customPrivate": false
  },
  conditional: {
    "json": {
      "===": [
        {
          "var": "data.terms"
        },
        "yes"
      ]
    }
  }
},
{
  "label": "Phone",
  "inputMask": "(99) 9999-9999",
  "tableView": true,
  "persistent": true,
  "validate": {
      "required": false,
      "customPrivate": false
  },
  conditional: {
    "json": {
      "===": [
        {
          "var": "data.terms"
        },
        "yes"
      ]
    }
  },
  "key": "applicantPhone",
  "type": "textfield",
  "input": true
},
{
  "label": "Fax",
  "inputMask": "(99) 9999-9999",
  "tableView": true,
  "persistent": true,
  "validate": {
      "required": false,
      "customPrivate": false
  },
  conditional: {
    "json": {
      "===": [
        {
          "var": "data.terms"
        },
        "yes"
      ]
    }
  },
  "key": "applicantFax",
  "type": "textfield",
  "input": true
},
{
  "label": "Email",
  "tableView": true,
  "validate": {
      "required": true
  },
  conditional: {
    "json": {
      "===": [
        {
          "var": "data.terms"
        },
        "yes"
      ]
    }
  },
  "key": "applicantEmail",
  "type": "email",
  "input": true
},
{
  type: "select",
  label: "Does the applicant retain advisors?",
  key: "retainAdvisers",
  placeholder: "Select one",
  data: {
    values: [
      {value: 'claimPreparer', label: 'Claim preparer'},
      {value: 'consultant', label: 'Consultant'},
      {value: 'solicitors', label: 'Solicitors'},
      {value: 'none', label: 'None'},
      {value: 'notKnown', label: 'Not known'}
    ]
  },
  dataSrc: "values",
  defaultValue: '',
  template: "<span>{{ item.label }}</span>",
  input: true,
  conditional: {
    "json": {
      "===": [
        {
          "var": "data.terms"
        },
        "yes"
      ]
    }
  }
},
//start for retain advisors
{
  "type": "htmlelement",
  "input": false,
  "tableView": true,
  "content": "Contact Person",
  "inputMask": "",
  "key": "retailAdvisorContactPersonText",
  "prefix": "",
  "suffix": "",
  "multiple": false,
  "protected": false,
  "unique": false,
  "persistent": true,
  conditional: {
    "json": {
      "in": [
        {
          "var": "data.retainAdvisers"
        },
        ["claimPreparer", "consultant", "solicitors"]
      ]
    }
  }
},
{
  "type": "textfield",
  "input": true,
  "tableView": true,
  "inputType": "text",
  "inputMask": "",
  "label": "",
  "key": "retailAdvisorContactPersonName",
  "placeholder": "Name",
  "prefix": "",
  "suffix": "",
  "multiple": false,
  "defaultValue": "",
  "protected": false,
  "unique": false,
  "persistent": true,
  "validate": {
      "required": true,
      "customPrivate": false
  },
  conditional: {
    "json": {
      "in": [
        {
          "var": "data.retainAdvisers"
        },
        ["claimPreparer", "consultant", "solicitors"]
      ]
    }
  }
},
{
"type": "textfield",
"input": true,
"tableView": true,
"inputType": "text",
"inputMask": "",
"label": "",
"key": "retailAdvisorContactPersonPosition",
"placeholder": "Position",
"prefix": "",
"suffix": "",
"multiple": false,
"defaultValue": "",
"protected": false,
"unique": false,
"persistent": true,
"validate": {
    "customPrivate": false
},
conditional: {
  "json": {
    "in": [
      {
        "var": "data.retainAdvisers"
      },
      ["claimPreparer", "consultant", "solicitors"]
    ]
  }
}
},
{
  "type": "htmlelement",
  "input": false,
  "tableView": true,
  "content": "Address",
  "inputMask": "",
  "key": "retailAdvisorAddressText",
  "prefix": "",
  "suffix": "",
  "multiple": false,
  "protected": false,
  "unique": false,
  "persistent": true,
  conditional: {
    "json": {
      "in": [
        {
          "var": "data.retainAdvisers"
        },
        ["claimPreparer", "consultant", "solicitors"]
      ]
    }
  }
},
{
  "type": "textfield",
  "input": true,
  "tableView": true,
  "inputType": "text",
  "inputMask": "",
  "label": "",
  "key": "retailAdvisorAddressNumberStreet",
  "placeholder": "Number/Street",
  "prefix": "",
  "suffix": "",
  "multiple": false,
  "defaultValue": "",
  "protected": false,
  "unique": false,
  "persistent": true,
  "validate": {
      "required": true,
      "customPrivate": false
  },
  conditional: {
    "json": {
      "in": [
        {
          "var": "data.retainAdvisers"
        },
        ["claimPreparer", "consultant", "solicitors"]
      ]
    }
  }
},
{
  "type": "textfield",
  "input": true,
  "tableView": true,
  "inputType": "text",
  "inputMask": "",
  "label": "",
  "key": "retailAdvisorSuburb",
  "placeholder": "Suburb",
  "prefix": "",
  "suffix": "",
  "multiple": false,
  "defaultValue": "",
  "protected": false,
  "unique": false,
  "persistent": true,
  "validate": {
      "required": true,
      "customPrivate": false
  },
  conditional: {
    "json": {
      "in": [
        {
          "var": "data.retainAdvisers"
        },
        ["claimPreparer", "consultant", "solicitors"]
      ]
    }
  }
},
{
  "type": "textfield",
  "input": true,
  "tableView": true,
  "inputType": "text",
  "inputMask": "",
  "label": "",
  "key": "retailAdvisorState",
  "placeholder": "State",
  "prefix": "",
  "suffix": "",
  "multiple": false,
  "defaultValue": "",
  "protected": false,
  "unique": false,
  "persistent": true,
  "validate": {
      "required": true,
      "customPrivate": false
  },
  conditional: {
    "json": {
      "in": [
        {
          "var": "data.retainAdvisers"
        },
        ["claimPreparer", "consultant", "solicitors"]
      ]
    }
  }
},
{
  "type": "textfield",
  "input": true,
  "tableView": true,
  "inputType": "text",
  "inputMask": "",
  "label": "",
  "key": "retailAdvisorPostCode",
  "placeholder": "Postcode",
  "prefix": "",
  "suffix": "",
  "multiple": false,
  "defaultValue": "",
  "protected": false,
  "unique": false,
  "persistent": true,
  "validate": {
      "required": true,
      "customPrivate": false
  },
  conditional: {
    "json": {
      "in": [
        {
          "var": "data.retainAdvisers"
        },
        ["claimPreparer", "consultant", "solicitors"]
      ]
    }
  }
},
{
  "label": "Phone",
  "inputMask": "(99) 9999-9999",
  "tableView": true,
  "persistent": true,
  "validate": {
      "required": false,
      "customPrivate": false
  },
  conditional: {
    "json": {
      "in": [
        {
          "var": "data.retainAdvisers"
        },
        ["claimPreparer", "consultant", "solicitors"]
      ]
    }
  },
  "key": "retailAdvisorPhone",
  "type": "textfield",
  "input": true
},
{
  "label": "Fax",
  "inputMask": "(99) 9999-9999",
  "tableView": true,
  "persistent": true,
  "validate": {
      "required": false,
      "customPrivate": false
  },
  conditional: {
    "json": {
      "in": [
        {
          "var": "data.retainAdvisers"
        },
        ["claimPreparer", "consultant", "solicitors"]
      ]
    }
  },
  "key": "retailAdvisorFax",
  "type": "textfield",
  "input": true
},
{
  "label": "Email",
  "tableView": true,
  "validate": {
      "required": true
  },
  conditional: {
    "json": {
      "in": [
        {
          "var": "data.retainAdvisers"
        },
        ["claimPreparer", "consultant", "solicitors"]
      ]
    }
  },
  "key": "retailAdvisorEmail",
  "type": "email",
  "input": true
},
//end for retain advisors

// start all fields from beginning for respondant
{
  "type": "textfield",
  "input": true,
  "tableView": true,
  "inputType": "text",
  "inputMask": "",
  "label": "Company (Respondent)",
  "key": "respondentName",
  "placeholder": "",
  "prefix": "",
  "suffix": "",
  "multiple": false,
  "defaultValue": "",
  "protected": false,
  "unique": false,
  "persistent": true,
  "validate": {
      "required": true,
      "customPrivate": false
  },
  conditional: {
  "json": {
    "===": [
      {
        "var": "data.terms"
      },
      "yes"
    ]
  }
}
},
{
  "type": "textfield",
  "input": true,
  "tableView": true,
  "inputType": "text",
  "inputMask": "",
  "label": "ABN/ACN",
  "key": "respondentABN",
  "placeholder": "",
  "prefix": "",
  "suffix": "",
  "multiple": false,
  "defaultValue": "",
  "protected": false,
  "unique": false,
  "persistent": true,
  "validate": {
      "required": true,
      "customPrivate": false
  },
  conditional: {
    "json": {
      "===": [
        {
          "var": "data.terms"
        },
        "yes"
      ]
    }
  }
},
{
  type: "select",
  label: "Business Structure",
  key: "respondentBusinessStructure",
  placeholder: "Select one",
  data: {
    values: [
      {value: 'Commonwealth Government', label: 'Commonwealth Government'},
      {value: 'Incorporated Association', label: 'Incorporated Association'},
      {value: 'Local Government', label: 'Local Government'},
      {value: 'Ltd Company', label: 'Ltd Company'},
      {value: 'Local Government', label: 'Local Government'},
      {value: 'Partnership', label: 'Partnership'},
      {value: 'Pty Ltd Company', label: 'Pty Ltd Company'},
      {value: 'Sole trader', label: 'Sole trader'},
      {value: 'State Government', label: 'State Government'},
      {value: 'Trust', label: 'Trust'},
      {value: 'Other', label: 'Other'}
    ]
  },
  dataSrc: "values",
  validate:{
    required: true
  },
  conditional: {
    "json": {
      "===": [
        {
          "var": "data.terms"
        },
        "yes"
      ]
    }
  },
  defaultValue: '',
  template: "<span>{{ item.label }}</span>",
  input: true
},
{
  type: "select",
  label: "Business Type/Activity",
  key: "respondentBusinessType",
  placeholder: "Select one",
  data: {
    values: [
      {value: 'Principal', label: 'Principal'},
      {value: 'Head contractor', label: 'Head contractor'},
      {value: 'Subcontractor', label: 'Subcontractor'},
      {value: 'Supplier', label: 'Supplier'},
      {value: 'Consultant', label: 'Consultant'},
      {value: 'Not Specified', label: 'Not Specified'}
    ]
  },
  dataSrc: "values",
  validate:{
  required: true
  },
  conditional: {
    "json": {
      "===": [
        {
          "var": "data.terms"
        },
        "yes"
      ]
    }
  },
  defaultValue: '',
  template: "<span>{{ item.label }}</span>",
  input: true
},
{
  "type": "htmlelement",
  "input": false,
  "tableView": true,
  "content": "Contact Person",
  "inputMask": "",
  "key": "respondentContactPersonText",
  "prefix": "",
  "suffix": "",
  "multiple": false,
  "protected": false,
  "unique": false,
  "persistent": true,
  "conditional": {
    "json": {
      "===": [
        {
          "var": "data.terms"
        },
        "yes"
      ]
    }
  }
},
{
  "type": "textfield",
  "input": true,
  "tableView": true,
  "inputType": "text",
  "inputMask": "",
  "label": "",
  "key": "respondentContactPersonName",
  "placeholder": "Name",
  "prefix": "",
  "suffix": "",
  "multiple": false,
  "defaultValue": "",
  "protected": false,
  "unique": false,
  "persistent": true,
  "validate": {
    "required": true,
    "customPrivate": false
  },
  conditional: {
    "json": {
      "===": [
        {
          "var": "data.terms"
        },
        "yes"
      ]
    }
  }
},
{
  "type": "textfield",
  "input": true,
  "tableView": true,
  "inputType": "text",
  "inputMask": "",
  "label": "",
  "key": "respondentContactPersonPosition",
  "placeholder": "Position",
  "prefix": "",
  "suffix": "",
  "multiple": false,
  "defaultValue": "",
  "protected": false,
  "unique": false,
  "persistent": true,
  "validate": {
  "customPrivate": false
  },
  conditional: {
    "json": {
      "===": [
      {
        "var": "data.terms"
      },
      "yes"
      ]
    }
  }
},
{
  "type": "htmlelement",
  "input": false,
  "tableView": true,
  "content": "Address",
  "inputMask": "",
  "key": "respondentAddressText",
  "prefix": "",
  "suffix": "",
  "multiple": false,
  "protected": false,
  "unique": false,
  "persistent": true,
  "conditional": {
    "json": {
      "===": [
        {
          "var": "data.terms"
        },
        "yes"
      ]
    }
  }
},
{
	"type": "textfield",
	"input": true,
	"tableView": true,
	"inputType": "text",
	"inputMask": "",
	"label": "",
	"key": "respondentAddressNumberStreet",
	"placeholder": "Number/Street",
	"prefix": "",
	"suffix": "",
	"multiple": false,
	"defaultValue": "",
	"protected": false,
	"unique": false,
	"persistent": true,
	"validate": {
		"required": true,
		"customPrivate": false
	},
	conditional: {
		"json": {
			"===": [
			{
			  "var": "data.terms"
			},
			"yes"
			]
		}
	}
},
{
	"type": "textfield",
	"input": true,
	"tableView": true,
	"inputType": "text",
	"inputMask": "",
	"label": "",
	"key": "respondentSuburb",
	"placeholder": "Suburb",
	"prefix": "",
	"suffix": "",
	"multiple": false,
	"defaultValue": "",
	"protected": false,
	"unique": false,
	"persistent": true,
	"validate": {
		"required": true,
		"customPrivate": false
	},
	conditional: {
		"json": {
			"===": [
			{
			  "var": "data.terms"
			},
			"yes"
			]
		}
	}
},
{
	"type": "textfield",
	"input": true,
	"tableView": true,
	"inputType": "text",
	"inputMask": "",
	"label": "",
	"key": "respondentState",
	"placeholder": "State",
	"prefix": "",
	"suffix": "",
	"multiple": false,
	"defaultValue": "",
	"protected": false,
	"unique": false,
	"persistent": true,
	"validate": {
	"required": true,
		"customPrivate": false
	},
	conditional: {
		"json": {
			"===": [
			  {
				"var": "data.terms"
			  },
			  "yes"
			]
		}
	}
},
{
	"type": "textfield",
	"input": true,
	"tableView": true,
	"inputType": "text",
	"inputMask": "",
	"label": "",
	"key": "respondentPostCode",
	"placeholder": "Postcode",
	"prefix": "",
	"suffix": "",
	"multiple": false,
	"defaultValue": "",
	"protected": false,
	"unique": false,
	"persistent": true,
	"validate": {
	"required": true,
		"customPrivate": false
	},
	conditional: {
		"json": {
			"===": [
			  {
				"var": "data.terms"
			  },
			  "yes"
			]
		}
	}
},
{
	"label": "Phone",
	"inputMask": "(99) 9999-9999",
	"tableView": true,
	"persistent": true,
	"validate": {
	"required": false,
	"customPrivate": false
	},
	conditional: {
	"json": {
	"===": [
	  {
		"var": "data.terms"
	  },
	  "yes"
	]
	}
	},
	"key": "respondentPhone",
	"type": "textfield",
	"input": true
},
{
	"label": "Fax",
	"inputMask": "(99) 9999-9999",
	"tableView": true,
	"persistent": true,
	"validate": {
	"required": false,
		"customPrivate": false
	},
	conditional: {
		"json": {
			"===": [
			  {
				"var": "data.terms"
			  },
			  "yes"
			]
		}
	},
	"key": "respondentFax",
	"type": "textfield",
	"input": true
},
{
	"label": "Email",
	"tableView": true,
	"validate": {
		"required": true
	},
	conditional: {
		"json": {
			"===": [
			  {
				"var": "data.terms"
			  },
			  "yes"
			]
		}
	},
	"key": "respondentEmail",
	"type": "email",
	"input": true
},
{
	type: "select",
	label: "Does the applicant retain advisors?",
	key: "respondentRetainAdvisers",
	placeholder: "Select one",
	data: {
	values: [
		{value: 'responsePreparer', label: 'Response preparer'},
		{value: 'consultant', label: 'Consultant'},
		{value: 'solicitors', label: 'Solicitors'},
		{value: 'none', label: 'None'},
		{value: 'notKnown', label: 'Not known'}
	]
	},
	dataSrc: "values",
	defaultValue: '',
	template: "<span>{{ item.label }}</span>",
	input: true,
	conditional: {
		"json": {
			"===": [
			  {
				"var": "data.terms"
			  },
			  "yes"
			]
		}
	}
},
//start for retain advisors
{
	"type": "htmlelement",
	"input": false,
	"tableView": true,
	"content": "Contact Person",
	"inputMask": "",
	"key": "respondentRetailAdvisorContactPersonText",
	"prefix": "",
	"suffix": "",
	"multiple": false,
	"protected": false,
	"unique": false,
	"persistent": true,
	conditional: {
		"json": {
			"in": [
			  {
				"var": "data.respondentRetainAdvisers"
			  },
			  ["responsePreparer", "consultant", "solicitors"]
			]
		}
	}
},
{
	"type": "textfield",
	"input": true,
	"tableView": true,
	"inputType": "text",
	"inputMask": "",
	"label": "",
	"key": "respondentRetailAdvisorContactPersonName",
	"placeholder": "Name",
	"prefix": "",
	"suffix": "",
	"multiple": false,
	"defaultValue": "",
	"protected": false,
	"unique": false,
	"persistent": true,
	"validate": {
	"required": true,
		"customPrivate": false
	},
	conditional: {
		"json": {
			"in": [
			  {
				"var": "data.respondentRetainAdvisers"
			  },
			  ["responsePreparer", "consultant", "solicitors"]
			]
		}
	}
},
{
	"type": "textfield",
	"input": true,
	"tableView": true,
	"inputType": "text",
	"inputMask": "",
	"label": "",
	"key": "respondentRetailAdvisorContactPersonPosition",
	"placeholder": "Position",
	"prefix": "",
	"suffix": "",
	"multiple": false,
	"defaultValue": "",
	"protected": false,
	"unique": false,
	"persistent": true,
	"validate": {
		"customPrivate": false
	},
	conditional: {
		"json": {
			"in": [
			{
			  "var": "data.respondentRetainAdvisers"
			},
			["responsePreparer", "consultant", "solicitors"]
			]
		}
	}
},
{
	"type": "htmlelement",
	"input": false,
	"tableView": true,
	"content": "Address",
	"inputMask": "",
	"key": "respondentRetailAdvisorAddressText",
	"prefix": "",
	"suffix": "",
	"multiple": false,
	"protected": false,
	"unique": false,
	"persistent": true,
	conditional: {
		"json": {
			"in": [
			  {
				"var": "data.respondentRetainAdvisers"
			  },
			  ["responsePreparer", "consultant", "solicitors"]
			]
		}
	}
},
{
	"type": "textfield",
	"input": true,
	"tableView": true,
	"inputType": "text",
	"inputMask": "",
	"label": "",
	"key": "respondentRetailAdvisorAddressNumberStreet",
	"placeholder": "Number/Street",
	"prefix": "",
	"suffix": "",
	"multiple": false,
	"defaultValue": "",
	"protected": false,
	"unique": false,
	"persistent": true,
	"validate": {
		"required": true,
		"customPrivate": false
	},
	conditional: {
		"json": {
			"in": [
			  {
				"var": "data.respondentRetainAdvisers"
			  },
			  ["responsePreparer", "consultant", "solicitors"]
			]
		}
	}
},
{
	"type": "textfield",
	"input": true,
	"tableView": true,
	"inputType": "text",
	"inputMask": "",
	"label": "",
	"key": "respondentRetailAdvisorSuburb",
	"placeholder": "Suburb",
	"prefix": "",
	"suffix": "",
	"multiple": false,
	"defaultValue": "",
	"protected": false,
	"unique": false,
	"persistent": true,
	"validate": {
		"required": true,
		"customPrivate": false
	},
	conditional: {
		"json": {
			"in": [
			  {
				"var": "data.respondentRetainAdvisers"
			  },
			  ["responsePreparer", "consultant", "solicitors"]
			]
		}
	}
},
{
  "type": "textfield",
  "input": true,
  "tableView": true,
  "inputType": "text",
  "inputMask": "",
  "label": "",
  "key": "respondentRetailAdvisorState",
  "placeholder": "State",
  "prefix": "",
  "suffix": "",
  "multiple": false,
  "defaultValue": "",
  "protected": false,
  "unique": false,
  "persistent": true,
  "validate": {
  "required": true,
  "customPrivate": false
},
  conditional: {
    "json": {
      "in": [
        {
          "var": "data.respondentRetainAdvisers"
        },
        ["responsePreparer", "consultant", "solicitors"]
      ]
    }
  }
},
{
  "type": "textfield",
  "input": true,
  "tableView": true,
  "inputType": "text",
  "inputMask": "",
  "label": "",
  "key": "respondentRetailAdvisorPostCode",
  "placeholder": "Postcode",
  "prefix": "",
  "suffix": "",
  "multiple": false,
  "defaultValue": "",
  "protected": false,
  "unique": false,
  "persistent": true,
  "validate": {
  "required": true,
  "customPrivate": false
  },
  conditional: {
    "json": {
      "in": [
        {
          "var": "data.respondentRetainAdvisers"
        },
        ["responsePreparer", "consultant", "solicitors"]
      ]
      }
  }
},
{
  "label": "Phone",
  "inputMask": "(99) 9999-9999",
  "tableView": true,
  "persistent": true,
  "validate": {
  "required": false,
  "customPrivate": false
  },
  conditional: {
    "json": {
      "in": [
        {
          "var": "data.respondentRetainAdvisers"
        },
        ["responsePreparer", "consultant", "solicitors"]
      ]
    }
  },
  "key": "respondentRetailAdvisorPhone",
  "type": "textfield",
  "input": true
},
{
  "label": "Fax",
  "inputMask": "(99) 9999-9999",
  "tableView": true,
  "persistent": true,
  "validate": {
  "required": false,
  "customPrivate": false
  },
  conditional: {
    "json": {
      "in": [
        {
          "var": "data.respondentRetainAdvisers"
        },
        ["responsePreparer", "consultant", "solicitors"]
      ]
    }
  },
  "key": "respondentRetailAdvisorFax",
  "type": "textfield",
  "input": true
},
{
  "label": "Email",
  "tableView": true,
  "validate": {
    "required": true
  },
  conditional: {
    "json": {
      "in": [
        {
          "var": "data.respondentRetainAdvisers"
        },
        ["responsePreparer", "consultant", "solicitors"]
      ]
    }
  },
  "key": "respondentRetailAdvisorEmail",
  "type": "email",
  "input": true
},
// end all fields from beginning for respondent
{
  "type": "radio",
  "label": "Does the contract fall under the definition of a contract for construction work or related good & services under (relevant legislation)?",
  "input": true,
  "inline": true,
  "tableView": false,
  "key": "contractDefinition",
  "persistent": true,
    values: [
      {value: 'yes', label: 'Yes'},
      {value: 'no', label: 'No'}
    ],
    "validate": {
      "required": true
  },
  conditional: {
    "json": {
      "===": [
        {
          "var": "data.terms"
        },
        "yes"
      ]
    }
  }
},
{
  "type": "htmlelement",
  "input": false,
  "tableView": true,
  "content": "Your claim may be invalid under (relevant legislation)",
  "inputMask": "",
  "key": "contractNotUnderDefinitionText",
  "prefix": "",
  "suffix": "",
  "multiple": false,
  "protected": false,
  "unique": false,
  "persistent": true,
  "conditional": {
    "json": {
      "===": [
        {
          "var": "data.contractDefinition"
        },
        "no"
      ]
    }
  }
},
{
  "label": "Date construction contract was entered into",
  "format": "yyyy-MM-dd",
  "tableView": false,
  "enableMinDateInput": false,
  "datePicker": {
      "disableWeekends": false,
      "disableWeekdays": false
  },
  "enableMaxDateInput": false,
  "enableTime": false,
  "timePicker": {
      "showMeridian": false
  },
  conditional: {
    "json": {
      "===": [
        {
          "var": "data.terms"
        },
        "yes"
      ]
    }
  },
  "key": "dateConstructionContractWasEnteredInto",
  "type": "datetime",
  "input": true,
  "widget": {
      "type": "calendar",
      "displayInTimezone": "viewer",
      "locale": "en",
      "useLocaleSettings": false,
      "allowInput": true,
      "mode": "single",
      "enableTime": false,
      "noCalendar": false,
      "format": "yyyy-MM-dd",
      "hourIncrement": 1,
      "minuteIncrement": 1,
      "time_24hr": true,
      "minDate": null,
      "disableWeekends": false,
      "disableWeekdays": false,
      "maxDate": null
  }
},
{
  "label": "Last date on which the relevant construction work was carried out",
  "format": "yyyy-MM-dd",
  "tableView": false,
  "enableMinDateInput": false,
  "datePicker": {
      "disableWeekends": false,
      "disableWeekdays": false
  },
  "enableMaxDateInput": false,
  "enableTime": false,
  "timePicker": {
      "showMeridian": false
  },
  conditional: {
    "json": {
      "===": [
        {
          "var": "data.terms"
        },
        "yes"
      ]
    }
  },
  "key": "lastDateRelevantConstructionWorkCarriedOut",
  "type": "datetime",
  "input": true,
  "widget": {
      "type": "calendar",
      "displayInTimezone": "viewer",
      "locale": "en",
      "useLocaleSettings": false,
      "allowInput": true,
      "mode": "single",
      "enableTime": false,
      "noCalendar": false,
      "format": "yyyy-MM-dd",
      "hourIncrement": 1,
      "minuteIncrement": 1,
      "time_24hr": true,
      "minDate": null,
      "disableWeekends": false,
      "disableWeekdays": false,
      "maxDate": null
  },
  "validate": {
    "required": true
  }
},
{
  "type": "textarea",
  "input": true,
  "tableView": true,
  "inputType": "text",
  "inputMask": "",
  "label": "Description of project",
  "key": "projectDescription",
  "placeholder": "",
  "prefix": "",
  "suffix": "",
  "multiple": false,
  "defaultValue": "",
  "protected": false,
  "unique": false,
  "persistent": true,
  "validate": {
      "required": true,
      "customPrivate": false
  },
  conditional: {
    "json": {
      "===": [
        {
          "var": "data.terms"
        },
        "yes"
      ]
    }
  }
},
{
  "type": "textfield",
  "input": true,
  "tableView": true,
  "inputType": "text",
  "inputMask": "",
  "label": "Postcode in which the relevant construction work took place",
  "key": "relaventConstructionPostCode",
  "placeholder": "",
  "prefix": "",
  "suffix": "",
  "multiple": false,
  "defaultValue": "",
  "protected": false,
  "unique": false,
  "persistent": true,
  "validate": {
      "required": true,
      "customPrivate": false
  },
  conditional: {
    "json": {
      "===": [
        {
          "var": "data.terms"
        },
        "yes"
      ]
    }
  }
},
{
  "type": "fileupload",
  "label": "Claimant submissons (e.g. contract, supporting docs)",
  "disabled": false,
  "value": 1,
  conditional: {
    "json": {
      "===": [
        {
          "var": "data.terms"
        },
        "yes"
      ]
    }
  }
},
{
  "type": "radio",
  "label": "The relevant details regarding payment claims can be found in (relevant legislation): Was a payment claim served?",
  "input": true,
  "inline": true,
  "tableView": false,
  "key": "paymentClaimServed",
  "persistent": true,
    values: [
      {value: 'yes', label: 'Yes'},
      {value: 'no', label: 'No'}
    ],
    "validate": {
      "required": true
  },
  conditional: {
    "json": {
      "===": [
        {
          "var": "data.terms"
        },
        "yes"
      ]
    }
  }
},
{
  "type": "htmlelement",
  "input": false,
  "tableView": true,
  "content": "Your claim may be invalid under (relevant legislation)",
  "inputMask": "",
  "key": "claimUnderLegislationText",
  "prefix": "",
  "suffix": "",
  "multiple": false,
  "protected": false,
  "unique": false,
  "persistent": true,
  "conditional": {
    "json": {
      "===": [
        {
          "var": "data.paymentClaimServed"
        },
        "no"
      ],
    }
  }
},
{
  "type": "radio",
  "label": "State that the claim was made under (relevant legislation)?",
  "input": true,
  "inline": true,
  "tableView": false,
  "key": "claimUnderLegislation",
  "persistent": true,
    values: [
      {value: 'yes', label: 'Yes'},
      {value: 'no', label: 'No'}
    ],
    "validate": {
      "required": true
  },
  conditional: {
    "json": {
      "===": [
        {
          "var": "data.terms"
        },
        "yes"
      ]
    }
  }
},
{
  "type": "htmlelement",
  "input": false,
  "tableView": true,
  "content": "Your claim may be invalid under (relevant legislation)",
  "inputMask": "",
  "key": "claimUnderLegislationText1",
  "prefix": "",
  "suffix": "",
  "multiple": false,
  "protected": false,
  "unique": false,
  "persistent": true,
  "conditional": {
    "json": {
      "===": [
        {
          "var": "data.claimUnderLegislation"
        },
        "no"
      ],
    }
  }
},
{
  "type": "radio",
  "label": "Did the payment claim identify the relevant work or related goods and services?",
  "input": true,
  "inline": true,
  "tableView": false,
  "key": "paymentClaimIdentifyRelaventWork",
  "persistent": true,
    values: [
      {value: 'yes', label: 'Yes'},
      {value: 'no', label: 'No'}
    ],
    "validate": {
      "required": true
  },
  conditional: {
    "json": {
      "===": [
        {
          "var": "data.terms"
        },
        "yes"
      ]
    }
  }
},
{
  "type": "htmlelement",
  "input": false,
  "tableView": true,
  "content": "Your claim may be invalid under (relevant legislation)",
  "inputMask": "",
  "key": "claimUnderLegislationText3",
  "prefix": "",
  "suffix": "",
  "multiple": false,
  "protected": false,
  "unique": false,
  "persistent": true,
  "conditional": {
    "json": {
      "===": [
        {
          "var": "data.paymentClaimIdentifyRelaventWork"
        },
        "no"
      ],
    }
  }
},
{
  "label": "Currency",
  "mask": false,
  "spellcheck": true,
  "tableView": false,
  "currency": "AUD",
  "inputFormat": "plain",
  "key": "currency",
  "type": "currency",
  "input": true,
  "delimiter": true,
  "validate": {
      "required": true,
      "customPrivate": false
  },
  conditional: {
    "json": {
      "===": [
        {
          "var": "data.terms"
        },
        "yes"
      ]
    }
  }
},
{
    "label": "Date of Claim",
    "format": "yyyy-MM-dd",
    "tableView": false,
    "enableMinDateInput": false,
    "datePicker": {
        "disableWeekends": false,
        "disableWeekdays": false
    },
    "enableMaxDateInput": false,
    "enableTime": false,
    "timePicker": {
        "showMeridian": false
    },
    "key": "dateOfClaim",
    "type": "datetime",
    "input": true,
    "widget": {
        "type": "calendar",
        "displayInTimezone": "viewer",
        "locale": "en",
        "useLocaleSettings": false,
        "allowInput": true,
        "mode": "single",
        "enableTime": false,
        "noCalendar": false,
        "format": "yyyy-MM-dd",
        "hourIncrement": 1,
        "minuteIncrement": 1,
        "time_24hr": true,
        "minDate": null,
        "disableWeekends": false,
        "disableWeekdays": false,
        "maxDate": null
    },
    "validate": {
      "required": true,
      "customPrivate": false
    },
    conditional: {
      "json": {
        "===": [
          {
            "var": "data.terms"
          },
          "yes"
        ]
      }
    }
  },
  {
    "type": "htmlelement",
    "input": false,
    "tableView": true,
    "content": "Your payment claim may be ineligible under s13 (4)(b) of the Act",
    "inputMask": "",
    "key": "claimUnderLegislationText3",
    "prefix": "",
    "suffix": "",
    "multiple": false,
    "protected": false,
    "unique": false,
    "persistent": true,
    "conditional": {
      "json": {
        ">": [
          {
            "var": "data.dateOfClaim"
          },
          "moment().toISOString()"
        ],
      }
    }
  },
  {
    "label": "Date served",
    "format": "yyyy-MM-dd",
    "tableView": false,
    "enableMinDateInput": false,
    "datePicker": {
        "disableWeekends": false,
        "disableWeekdays": false
    },
    "enableMaxDateInput": false,
    "enableTime": false,
    "timePicker": {
        "showMeridian": false
    },
    "key": "dateServed",
    "type": "datetime",
    "input": true,
    "widget": {
        "type": "calendar",
        "displayInTimezone": "viewer",
        "locale": "en",
        "useLocaleSettings": false,
        "allowInput": true,
        "mode": "single",
        "enableTime": false,
        "noCalendar": false,
        "format": "yyyy-MM-dd",
        "hourIncrement": 1,
        "minuteIncrement": 1,
        "time_24hr": true,
        "minDate": null,
        "disableWeekends": false,
        "disableWeekdays": false,
        "maxDate": null
    },
    "validate": {
      "required": true,
      "customPrivate": false
    },
    conditional: {
      "json": {
        "===": [
          {
            "var": "data.terms"
          },
          "yes"
        ]
      }
    }
  },
  {
    "label": "Due date for payment",
    "format": "yyyy-MM-dd",
    "tableView": false,
    "enableMinDateInput": false,
    "datePicker": {
        "disableWeekends": false,
        "disableWeekdays": false
    },
    "enableMaxDateInput": false,
    "enableTime": false,
    "timePicker": {
        "showMeridian": false
    },
    "key": "dueDatForPayment",
    "type": "datetime",
    "input": true,
    "widget": {
        "type": "calendar",
        "displayInTimezone": "viewer",
        "locale": "en",
        "useLocaleSettings": false,
        "allowInput": true,
        "mode": "single",
        "enableTime": false,
        "noCalendar": false,
        "format": "yyyy-MM-dd",
        "hourIncrement": 1,
        "minuteIncrement": 1,
        "time_24hr": true,
        "minDate": null,
        "disableWeekends": false,
        "disableWeekdays": false,
        "maxDate": null
    },
    "validate": {
      "required": true,
      "customPrivate": false
    },
    conditional: {
      "json": {
        "===": [
          {
            "var": "data.terms"
          },
          "yes"
        ]
      }
    }
  },
  {
    "label": "Reference date",
    "format": "yyyy-MM-dd",
    "tableView": false,
    "enableMinDateInput": false,
    "datePicker": {
        "disableWeekends": false,
        "disableWeekdays": false
    },
    "enableMaxDateInput": false,
    "enableTime": false,
    "timePicker": {
        "showMeridian": false
    },
    "key": "referenceDate",
    "type": "datetime",
    "input": true,
    "widget": {
        "type": "calendar",
        "displayInTimezone": "viewer",
        "locale": "en",
        "useLocaleSettings": false,
        "allowInput": true,
        "mode": "single",
        "enableTime": false,
        "noCalendar": false,
        "format": "yyyy-MM-dd",
        "hourIncrement": 1,
        "minuteIncrement": 1,
        "time_24hr": true,
        "minDate": null,
        "disableWeekends": false,
        "disableWeekdays": false,
        "maxDate": null
    },
    "validate": {
      "required": true,
      "customPrivate": false
    },
    "conditional": {
      "json": {
        "===": [
          {
            "var": "applicantState"
          },
          "VIC"
        ]
      }
    }
  },
  {
    "type": "htmlelement",
    "input": false,
    "tableView": true,
    "content": "Your payment claim may be ineligible under s14 (4)(b) of the Act",
    "inputMask": "",
    "key": "claimUnderLegislationText4",
    "prefix": "",
    "suffix": "",
    "multiple": false,
    "protected": false,
    "unique": false,
    "persistent": true,
    "conditional": {
      "json": {
        "and": [
          {"<": [{"var": "data.referenceDate"}, checkRefDate]},
          {">": [{"var": "data.referenceDate"}, "0000-00-00T00:00:00+11:00"]},
          {"===": [{"var": "data.applicantState"}, "NSW"]}

        ]
      }
    }
  },
  {
    "type": "radio",
    "label": "The relevant details regarding payment schedules can be found in (relevant legislation) Was a payment Schedule provided?",
    "input": true,
    "inline": true,
    "tableView": false,
    "key": "relaventDetailsRegardingPaymentSchedule",
    "persistent": true,
      values: [
        {value: 'yes', label: 'Yes'},
        {value: 'no', label: 'No'}
      ],
      "validate": {
        "required": true
      },
      conditional: {
        "json": {
          "===": [
            {
              "var": "data.terms"
            },
            "yes"
          ]
        }
      }
  },
  {
    "type": "htmlelement",
    "input": false,
    "tableView": true,
    "content": "Your payment claim may be ineligible under s14 (4)(b) of the Act",
    "inputMask": "",
    "key": "claimUnderLegislationText_relaventDetailsRegardingPaymentSchedule",
    "prefix": "",
    "suffix": "",
    "multiple": false,
    "protected": false,
    "unique": false,
    "persistent": true,
    "conditional": {
      "json": {
        "===": [
          {
            "var": "relaventDetailsRegardingPaymentSchedule"
          },
          "no"
        ]
      }
    }
  },



  {
    "type": "radio",
    "label": "Did the payment schedule Identify the relevant claim?",
    "input": true,
    "inline": true,
    "tableView": false,
    "key": "paymentScheduleIdentityRelaventClaim",
    "persistent": true,
      values: [
        {value: 'yes', label: 'Yes'},
        {value: 'no', label: 'No'}
      ],
      "validate": {
        "required": true
      },
      "conditional": {
        "json": {
          "===": [
            {
              "var": "relaventDetailsRegardingPaymentSchedule"
            },
            "yes"
          ],
        }
      }
  },
  {
    "type": "htmlelement",
    "input": false,
    "tableView": true,
    "content": "Your claim may be invalid under (relevant legislation)",
    "inputMask": "",
    "key": "claimUnderLegislationText_paymentScheduleIdentityRelaventClaim",
    "prefix": "",
    "suffix": "",
    "multiple": false,
    "protected": false,
    "unique": false,
    "persistent": true,
    "conditional": {
      "json": {
        "===": [
          {
            "var": "paymentScheduleIdentityRelaventClaim"
          },
          "no"
        ],
      }
    }
  },
  {
    "type": "radio",
    "label": "Did the payment schedule Identify the relevant claim?",
    "input": true,
    "inline": true,
    "tableView": false,
    "key": "IdentifiesClaim",
    "persistent": true,
      values: [
        {value: 'yes', label: 'Yes'},
        {value: 'no', label: 'No'}
      ],
      "validate": {
        "required": true
      },
      "conditional": {
        "json": {
          "===": [
            {
              "var": "relaventDetailsRegardingPaymentSchedule"
            },
            "yes"
          ],
        }
      }
  },
  {
    "label": "Scheduled amount (excl. GST)",
    "mask": false,
    "spellcheck": true,
    "tableView": false,
    "currency": "AUD",
    "inputFormat": "plain",
    "key": "scheduledAmount",
    "type": "currency",
    "input": true,
    "delimiter": true,
    "validate": {
        "required": true,
        "customPrivate": false
    },
    "conditional": {
      "json": {
        "===": [
          {
            "var": "relaventDetailsRegardingPaymentSchedule"
          },
          "yes"
        ],
      }
    }
  },
  {
    "label": "Excluded amount (excl.GST)",
    "mask": false,
    "spellcheck": true,
    "tableView": false,
    "currency": "AUD",
    "inputFormat": "plain",
    "key": "excludedAmount",
    "type": "currency",
    "input": true,
    "delimiter": true,
    "validate": {
        "required": true,
        "customPrivate": false
    },
    "conditional": {
      "json": {
        "===": [
          {
            "var": "relaventDetailsRegardingPaymentSchedule"
          },
          "yes"
        ],
      }
    }
  },
  {
    "type": "textfield",
    "input": true,
    "tableView": true,
    "inputType": "text",
    "inputMask": "",
    "label": "If the scheduled amount was less than claimed amount, did  reasons for withholding the difference?",
    "key": "reasonForWithholding",
    "placeholder": "Name",
    "prefix": "",
    "suffix": "",
    "multiple": false,
    "defaultValue": "",
    "protected": false,
    "unique": false,
    "persistent": true,
    "validate": {
        "required": true,
        "customPrivate": false
    },
    "conditional": {
      "json": {
        "===": [
          {
            "var": "relaventDetailsRegardingPaymentSchedule"
          },
          "yes"
        ],
      }
    }
  },
  {
    "label": "Schedule Date",
    "format": "yyyy-MM-dd",
    "tableView": false,
    "enableMinDateInput": false,
    "datePicker": {
        "disableWeekends": false,
        "disableWeekdays": false
    },
    "enableMaxDateInput": false,
    "enableTime": false,
    "timePicker": {
        "showMeridian": false
    },
    conditional: {
      "json": {
        "===": [
          {
            "var": "relaventDetailsRegardingPaymentSchedule"
          },
          "yes"
        ]
      }
    },
    "key": "scheduleDate",
    "type": "datetime",
    "input": true,
    "widget": {
        "type": "calendar",
        "displayInTimezone": "viewer",
        "locale": "en",
        "useLocaleSettings": false,
        "allowInput": true,
        "mode": "single",
        "enableTime": false,
        "noCalendar": false,
        "format": "yyyy-MM-dd",
        "hourIncrement": 1,
        "minuteIncrement": 1,
        "time_24hr": true,
        "minDate": null,
        "disableWeekends": false,
        "disableWeekdays": false,
        "maxDate": null
    }
  },
  {
    "label": "Date received",
    "format": "yyyy-MM-dd",
    "tableView": false,
    "enableMinDateInput": false,
    "datePicker": {
        "disableWeekends": false,
        "disableWeekdays": false
    },
    "enableMaxDateInput": false,
    "enableTime": false,
    "timePicker": {
        "showMeridian": false
    },
    conditional: {
      "json": {
        "===": [
          {
            "var": "relaventDetailsRegardingPaymentSchedule"
          },
          "yes"
        ]
      }
    },
    "key": "dateReceived",
    "type": "datetime",
    "input": true,
    "widget": {
        "type": "calendar",
        "displayInTimezone": "viewer",
        "locale": "en",
        "useLocaleSettings": false,
        "allowInput": true,
        "mode": "single",
        "enableTime": false,
        "noCalendar": false,
        "format": "yyyy-MM-dd",
        "hourIncrement": 1,
        "minuteIncrement": 1,
        "time_24hr": true,
        "minDate": null,
        "disableWeekends": false,
        "disableWeekdays": false,
        "maxDate": null
    }
  },
  {
    "label": "Due date for payment",
    "format": "yyyy-MM-dd",
    "tableView": false,
    "enableMinDateInput": false,
    "datePicker": {
        "disableWeekends": false,
        "disableWeekdays": false
    },
    "enableMaxDateInput": false,
    "enableTime": false,
    "timePicker": {
        "showMeridian": false
    },
    conditional: {
      "json": {
        "===": [
          {
            "var": "relaventDetailsRegardingPaymentSchedule"
          },
          "yes"
        ]
      }
    },
    "key": "dueDateForPayment",
    "type": "datetime",
    "input": true,
    "widget": {
        "type": "calendar",
        "displayInTimezone": "viewer",
        "locale": "en",
        "useLocaleSettings": false,
        "allowInput": true,
        "mode": "single",
        "enableTime": false,
        "noCalendar": false,
        "format": "yyyy-MM-dd",
        "hourIncrement": 1,
        "minuteIncrement": 1,
        "time_24hr": true,
        "minDate": null,
        "disableWeekends": false,
        "disableWeekdays": false,
        "maxDate": null
    }
  },
  {
    "type": "radio",
    "label": "Details about the notice of Intention to adjudicate can be found in (relevant legislation), Was an notice to apply for adjudication served?",
    "input": true,
    "inline": true,
    "tableView": false,
    "key": "etailsAboutTheNoticeOfIntentionToAdjudicate",
    "persistent": true,
      values: [
        {value: 'yes', label: 'Yes'},
        {value: 'no', label: 'No'}
      ],
      "validate": {
        "required": true
      },
      conditional: {
        "json": {
          "===": [
            {
              "var": "data.terms"
            },
            "yes"
          ]
        }
      }
  },
  {
    "type": "htmlelement",
    "input": false,
    "tableView": true,
    "content": "Your claim may be invalid under (relevant legislation) NSW: s17(2)",
    "inputMask": "",
    "key": "claimUnderLegislationText_etailsAboutTheNoticeOfIntentionToAdjudicate_NSW",
    "prefix": "",
    "suffix": "",
    "multiple": false,
    "protected": false,
    "unique": false,
    "persistent": true,
    "conditional": {
      "json": {
        "and": [
          {"===": [{"var": "data.etailsAboutTheNoticeOfIntentionToAdjudicate"},"no"]},
          {"==": [{"var": "data.applicantState"}, "NSW"]},
        ],
      }
    }
  },
  {
    "type": "htmlelement",
    "input": false,
    "tableView": true,
    "content": "Your claim may be invalid under (relevant legislation) VIC: s18(2)",
    "inputMask": "",
    "key": "claimUnderLegislationText_etailsAboutTheNoticeOfIntentionToAdjudicate_VIC",
    "prefix": "",
    "suffix": "",
    "multiple": false,
    "protected": false,
    "unique": false,
    "persistent": true,
    "conditional": {
      "json": {
        "and": [
          {"===": [{"var": "data.etailsAboutTheNoticeOfIntentionToAdjudicate"},"no"]},
          {"==": [{"var": "data.applicantState"}, "VIC"]},
        ],
      }
    }
  },
  {
    "type": "htmlelement",
    "input": false,
    "tableView": true,
    "content": "Your claim may be invalid under (relevant legislation) SA: s17(2)",
    "inputMask": "",
    "key": "claimUnderLegislationText_etailsAboutTheNoticeOfIntentionToAdjudicate_SA",
    "prefix": "",
    "suffix": "",
    "multiple": false,
    "protected": false,
    "unique": false,
    "persistent": true,
    "conditional": {
      "json": {
        "and": [
          {"===": [{"var": "data.etailsAboutTheNoticeOfIntentionToAdjudicate"},"no"]},
          {"==": [{"var": "data.applicantState"}, "SA"]},
        ],
      }
    }
  },
  {
    "type": "htmlelement",
    "input": false,
    "tableView": true,
    "content": "Your claim may be invalid under (relevant legislation) ACT: s19(2)",
    "inputMask": "",
    "key": "claimUnderLegislationText_etailsAboutTheNoticeOfIntentionToAdjudicate_ACT",
    "prefix": "",
    "suffix": "",
    "multiple": false,
    "protected": false,
    "unique": false,
    "persistent": true,
    "conditional": {
      "json": {
        "and": [
          {"===": [{"var": "data.etailsAboutTheNoticeOfIntentionToAdjudicate"},"no"]},
          {"==": [{"var": "data.applicantState"}, "ACT"]},
        ],
      }
    }
  },
  {
    "type": "htmlelement",
    "input": false,
    "tableView": true,
    "content": "Your claim may be invalid under (relevant legislation) TAS:s21(4)",
    "inputMask": "",
    "key": "claimUnderLegislationText_etailsAboutTheNoticeOfIntentionToAdjudicate_TAS",
    "prefix": "",
    "suffix": "",
    "multiple": false,
    "protected": false,
    "unique": false,
    "persistent": true,
    "conditional": {
      "json": {
        "and": [
          {"===": [{"var": "data.etailsAboutTheNoticeOfIntentionToAdjudicate"},"no"]},
          {"==": [{"var": "data.applicantState"}, "TAS"]},
        ],
      }
    }
  },
  {
    "label": "Date served",
    "format": "yyyy-MM-dd",
    "tableView": false,
    "enableMinDateInput": false,
    "datePicker": {
        "disableWeekends": false,
        "disableWeekdays": false
    },
    "enableMaxDateInput": false,
    "enableTime": false,
    "timePicker": {
        "showMeridian": false
    },
    "key": "dateServed_72",
    "type": "datetime",
    "input": true,
    "widget": {
        "type": "calendar",
        "displayInTimezone": "viewer",
        "locale": "en",
        "useLocaleSettings": false,
        "allowInput": true,
        "mode": "single",
        "enableTime": false,
        "noCalendar": false,
        "format": "yyyy-MM-dd",
        "hourIncrement": 1,
        "minuteIncrement": 1,
        "time_24hr": true,
        "minDate": null,
        "disableWeekends": false,
        "disableWeekdays": false,
        "maxDate": null
    },
    "validate": {
      "required": true,
      "customPrivate": false
    },
    conditional: {
      "json": {
        "===": [
          {
            "var": "data.terms"
          },
          "yes"
        ]
      }
    }
  },
  {
    "type": "radio",
    "label": "Did the notice allow for (x) business days for respondent to provide payment schedule as per (x)?",
    "input": true,
    "inline": true,
    "tableView": false,
    "key": "didYouNoticeAllowBusinessDays",
    "persistent": true,
      values: [
        {value: 'yes', label: 'Yes'},
        {value: 'no', label: 'No'}
      ],
      "validate": {
        "required": true
    },
    conditional: {
      "json": {
        "===": [
          {
            "var": "data.terms"
          },
          "yes"
        ]
      }
    }
  },
  {
    "type": "htmlelement",
    "input": false,
    "tableView": true,
    "content": "If no PS served and TODAY > 15 business days after q72, and 20 business days after q62, Your claim may be invalid under s17(2) of the Act",
    "inputMask": "",
    "key": "claimUnderLegislationText_etailsAboutTheNoticeOfIntentionToAdjudicate_NSW",
    "prefix": "",
    "suffix": "",
    "multiple": false,
    "protected": false,
    "unique": false,
    "persistent": true,
    "conditional": {
      "json": {
        "and": [
          {"===": [{"var": "data.didYouNoticeAllowBusinessDays"},"no"]},
          {"==": [{"var": "data.applicantState"}, "NSW"]},
        ],
      }
    }
  },
  {
    "type": "htmlelement",
    "input": false,
    "tableView": true,
    "content": "If no PS served and TODAY > 7 business days after q72, after 10 business days from q62, Your claim may be invalid under s18(2) of the Act",
    "inputMask": "",
    "key": "claimUnderLegislationText_etailsAboutTheNoticeOfIntentionToAdjudicate_VIC",
    "prefix": "",
    "suffix": "",
    "multiple": false,
    "protected": false,
    "unique": false,
    "persistent": true,
    "conditional": {
      "json": {
        "and": [
          {"===": [{"var": "data.didYouNoticeAllowBusinessDays"},"no"]},
          {"==": [{"var": "data.applicantState"}, "VIC"]},
        ],
      }
    }
  },
  {
    "type": "htmlelement",
    "input": false,
    "tableView": true,
    "content": "If no PS served and TODAY > 20 business days after q72, and 20 business days after q62, Your claim may be invalid under s17(2) of the Act",
    "inputMask": "",
    "key": "claimUnderLegislationText_etailsAboutTheNoticeOfIntentionToAdjudicate_SA",
    "prefix": "",
    "suffix": "",
    "multiple": false,
    "protected": false,
    "unique": false,
    "persistent": true,
    "conditional": {
      "json": {
        "and": [
          {"===": [{"var": "data.didYouNoticeAllowBusinessDays"},"no"]},
          {"==": [{"var": "data.applicantState"}, "SA"]},
        ],
      }
    }
  },
  {
    "type": "htmlelement",
    "input": false,
    "tableView": true,
    "content": "If no PS served and TODAY > 15 business days after q72, after 10 business days from q62, Your claim may be invalid under s19(2) of the Act",
    "inputMask": "",
    "key": "claimUnderLegislationText_etailsAboutTheNoticeOfIntentionToAdjudicate_ACT",
    "prefix": "",
    "suffix": "",
    "multiple": false,
    "protected": false,
    "unique": false,
    "persistent": true,
    "conditional": {
      "json": {
        "and": [
          {"===": [{"var": "data.didYouNoticeAllowBusinessDays"},"no"]},
          {"==": [{"var": "data.applicantState"}, "ACT"]},
        ],
      }
    }
  },
  {
    "type": "htmlelement",
    "input": false,
    "tableView": true,
    "content": "If no PS served and TODAY > 15 business days after q72, and 20 business days after q62, Your claim may be invalid under s17(2) of the Act",
    "inputMask": "",
    "key": "claimUnderLegislationText_etailsAboutTheNoticeOfIntentionToAdjudicate_TAS",
    "prefix": "",
    "suffix": "",
    "multiple": false,
    "protected": false,
    "unique": false,
    "persistent": true,
    "conditional": {
      "json": {
        "and": [
          {"===": [{"var": "data.didYouNoticeAllowBusinessDays"},"no"]},
          {"==": [{"var": "data.applicantState"}, "TAS"]},
        ],
      }
    }
  },
  {
    "type": "radio",
    "label": "Declaration: I hereby declare that, The Information provided in this application is, to the best of my knowledge, accurate and truthful",
    "input": true,
    "inline": true,
    "tableView": false,
    "key": "userDeclarationText",
    "persistent": true,
      values: [
        {value: 'yes', label: 'Yes'},
        {value: 'no', label: 'No'}
      ],
      "validate": {
        "required": true
    },
    conditional: {
      "json": {
        "===": [
          {
            "var": "data.terms"
          },
          "yes"
        ]
      }
    }
  },
  {
    "type": "radio",
    "label": "Service declaration (see attached page)",
    "input": true,
    "inline": true,
    "tableView": false,
    "key": "serviceDeclaration",
    "persistent": true,
      values: [
        {value: 'yes', label: 'Yes'},
        {value: 'no', label: 'No'}
      ],
      "validate": {
        "required": true
    },
    conditional: {
      "json": {
        "===": [
          {
            "var": "data.terms"
          },
          "yes"
        ]
      }
    }
  },
{
  "type": "button",
  "label": "Submit",
  "key": "submit",
  "disableOnInvalid": true,
  "input": true,
  "tableView": false
}
]}
this.formData = {
  data: {
    "firstName": "Laksh",
    "lastName": "Mikkili"
  }
};
// attaching the function to window to access the function in json
(window as any).onCheck = function onCheck(abnVal: any){
  console.log("abnVal is" + abnVal);
};


(window as any).checkValid = function checkValid(value: any) {
  return value != null || value != ""
}
}

onSubmit(abc: any) {
  console.log(abc.data);
  this.router.navigateByUrl('/thankyou');
}
}
